export const UTILITIES_TABS = [
  'Get Phone Validation',
  'Upload Image',
  'Migrate Phone Verification',
  'Verify Account'
]
export const UTILITIES_TABS_INDEX = {
  PHOPNE_VALIDATION: 0,
  UPLOAD_IMAGE: 1,
  PHONE_MIGRATION: 2,
  VERIFY_ACCOUNT: 3
}
export const UTILITIES_FORM_FIELDS = {
  PHOPNE_VALIDATION: {
    ID: 'phoneNumber',
    LABEL: 'Phone Number',
    PLACEHOLDER: 'Enter number'
  },
  MIGRATE_PHOPNE_VERIFICATION: {
    OLD_USER_ID: {
      ID: 'oldUserID',
      LABEL: 'UserID from Account Verified',
      PLACEHOLDER: 'UserID'
    },
    NEW_USER_ID: {
      ID: 'newUserID',
      LABEL: 'UserID from Account to Receive the Verification',
      PLACEHOLDER: 'UserID'
    }
  },
  VERIFY_ACCOUNT: {
    USER_ID: {
      ID: 'userID',
      LABEL: 'UserID from the Account to be Verified',
      PLACEHOLDER: 'UserID'
    }
  }
}
export const UTILITIES_TAB_TEXT = {
  PHOPNE_VALIDATION: {
    TITLE: 'Get Phone Validation Code',
    DESCRIPTION:
      'Enter the phone number, including the country code to get the validation code.'
  },
  MIGRATE_PHOPNE_VERIFICATION: {
    TITLE: 'Migrate Phone Verification',
    DESCRIPTION:
      'Enter the UserID from the account verified and the account to move the verification to.'
  },
  IMAGE_UPLOAD: {
    TITLE: 'Upload an Image to the Server',
    DESCRIPTION: 'Press on the input to select the image to upload.'
  },
  VERIFY_ACCOUNT: {
    TITLE: 'Verify Account',
    DESCRIPTION: 'Enter the UserID for the account that should be verified.'
  }
}
export const NO_VALIDATION_CODE = 'No validation code found'
export const NUMBER_ONLY_REGEX = /^[0-9\b]+$/
export const MIGRATION_SUCCESS = 'Phone Verification Migrated'

export const IMAGE_UPLOAD_SUCCESS = 'Image Uploaded'
export const IMAGE_ID = 'Image ID'

export const IMAGE_UPLOAD_LABEL = 'Image to Upload'
export const MIGRATION_BTN_LABEL = 'Migrate Verification'

export const FORBIDDEN_NUMBER_INPUTS = ['e', 'E', '+', '-']

export const VERIFY_ACCOUNT_BTN_LABEL = 'Verify Account'
export const VERIFY_ACCOUNT_SUCCESS = 'Account Verified'

export const VALIDATE_USER_ACCOUNT_DIALOG_TITLE = 'Validate User Account'
export const VALIDATE_USER_ACCOUNT_DIALOG_DESCRIPTION =
  'If confirm, the user account {userID} will be marked as verified, and the user won&apos;t need to verify it with his phone number.'
